import { Text } from '@/design-system';

import { TextField } from '../TextField';

interface MonorepoSupportProps {
  installCommand: string;
  buildCommand: string;
  onInstallCommandChange: (value: string) => void;
  onBuildCommandChange: (value: string) => void;
}

export function MonorepoSupport({
  installCommand,
  buildCommand,
  onInstallCommandChange,
  onBuildCommandChange,
}: MonorepoSupportProps) {
  return (
    <>
      <div className="flex flex-col gap-1">
        <Text variant="h3">Monorepo Support</Text>

        <Text variant="body" color="tertiary">
          Currently only supported for JS projects. See the{' '}
          <a
            className="underline"
            target="_blank"
            href="https://docs.langchain.com/langgraph-platform/monorepo-support#monorepo-support"
          >
            docs
          </a>{' '}
          for more details.
        </Text>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <TextField
          label="Custom Install Command"
          onChange={(e) => onInstallCommandChange(e.target.value)}
          value={installCommand}
          placeholder="npm install"
        />
        <TextField
          label="Custom Build Command"
          onChange={(e) => onBuildCommandChange(e.target.value)}
          value={buildCommand}
          placeholder="npm run build"
        />
      </div>
    </>
  );
}
